import { apiInstance } from "../config/apiInstance"

export const patchData = async (url:string, data?:any) => {
    const response = await apiInstance.patch( url, data );
    return response
}